@if (getIcon()) {
	<span revTooltip [tooltipContent]="status.label">
    <i [class]="'fa app-status-icon text-success ' + getIcon()"></i>
  </span>
}
